import React, { useState, useEffect, useMemo } from "react";
import { Nav, Form, Tab, Modal } from "react-bootstrap";
import Header from "../../../Components/Header";
import axios from "axios";
import Loader from "../../../Components/Common/Loader";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import { Baseurl, PARTNER } from "../../../Configuration/Partner_URL";
import { Constants } from "../../../CommonMethhods/Constants";
import PartnerOnboardingAll from "../PartnerOnboardingComponent/PartnerOnboardingAll";
import PartnerOnboardingApproved from "../PartnerOnboardingComponent/PartnerOnboardingApproved";
import PartnerOnboardingRejected from "../PartnerOnboardingComponent/PartnerOnboardingRejected";
import PartnerOnboardingDraft from "../PartnerOnboardingComponent/PartnerOnboardingDraft";
import PartnerOnboardingActive from "../PartnerOnboardingComponent/PartnerOnboardingActive";
import PartnerOnboardingUnderReview from "../PartnerOnboardingComponent/PartnerOnbaordingUnderReview";
import { useDebounce } from "../../../Components/useDebounce";
import { toast } from "react-toastify";
import { decryptData, encryptData } from "../../../CommonMethhods/CommonMethods";
import SmallLoader from "../../../Components/Common/smallLoader";


function PartnerOnboardingDashboard() {
    const tabStatusCheck = localStorage.getItem("statusOfClient");
    const getFromDate= localStorage.getItem("dematLeadFromDate");
    const getToDate= localStorage.getItem("dematLeadToDate");
    const getDuration = localStorage.getItem("backofficeDuration");
    const storeToken = localStorage.getItem("ssoToken");
    const [linecard, setLinecard] = useState("block-active col-division-5");
    const [loader, setLoader] = useState(false);
    const [tabStatus, setTabStatus] = useState(tabStatusCheck !== null ? tabStatusCheck : "all");
    const [page, setPage] = useState(1);
    const [scrollLoader, setScrollLoader] = useState(false);
    const [partnerOnboardingData, setPartnerOnboardingData] = useState([])
    const [totalCount, setTotalCount] = useState();
    const [getDispositionMaster, setGetDispositionMaster] = useState([])
    const [partnerSource, setPartnerSource] = useState([])
    const [dayWiseDate, setDayWiseDate] = useState(getFromDate !== null && getToDate !== null ? "custom-range" : getDuration !== null ? getDuration : "this-month");
    const [customDate, setCustomDate] = useState(false)
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [name, setName] = useState("");
    const [downloadLoader, setDownloadLoader] = useState(false);
    if(storeToken == null){
        window.location.replace("/")
      }
    if(storeToken == null){
        window.location.replace("/");
      }
      
    // search bar code start
    const debouncedValue = useDebounce(name, 1000);
    useEffect(() => {
        if (debouncedValue) {
            handleSearchName(debouncedValue);
        }
    }, [debouncedValue]);

    const handleSearchName = () => {
        if (debouncedValue) {
            onboardingApiData(page, tabStatus, 10, dayWiseDate, debouncedValue);
            // setLoader(false);
        }
        setScrollLoader(false);
    };
    useEffect(() => {
        masterDisposition()
        masterPartner()
    }, [])
    useEffect(() => {
        if (localStorage.getItem("activeTab")) {
            setTabStatus(localStorage.getItem("activeTab"));
        }
        if(dayWiseDate !== ""){
          onboardingApiData(page, tabStatus, 10, dayWiseDate, name == "")
        }
        

        // else {
        //     onboardingApiData(page, tabStatus, 10, dayWiseDate, name == "")
        // }
        // return () => {
        //     localStorage.removeItem("activeTab");
        // };
    }, [page, tabStatus, dayWiseDate, name == ""]);

    if (storeToken == null) {
        window.location.replace("/");
    }
    function handleGridView(e) {
        if (linecard === "") setLinecard("block-active col-division-5");
    }

    function handleListView() {
        if (linecard === "block-active col-division-5") setLinecard("");
    }

    const onboardingApiData = async (pageNo = 1, tab, sizePage = 10, dayWise) => {
        if (page === 1) {
            setLoader(true);
          }
        try {
            const getOnboardingDetails = await axios.get(
                `${PARTNER.GET_PARTNER_DETAILS}?status=${tab}&page=${pageNo}&limit=${sizePage}&range=${dayWise}&to=${getToDate ? getToDate :toDate}&from=${getFromDate ? getFromDate : fromDate}&search=${name}`,

                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
            const res = decryptData(getOnboardingDetails?.data);
            const decryptionResponse = JSON.parse(res)

            if (decryptionResponse?.status === 0) {
                setTotalCount(decryptionResponse?.data?.count)
                if (pageNo > 1) {
                    setPartnerOnboardingData((prev) => {
                        return [...prev, ...decryptionResponse?.data?.partners];
                    });
                } else {
                    setPartnerOnboardingData(decryptionResponse?.data?.partners);
                }
            }
            else {
                setPartnerOnboardingData([])
            }
        } catch (error) {
            console.log(error, "err");
        }
        finally {
            setLoader(false);
            setScrollLoader(false);
            setDownloadLoader(false);
        }
    };
    const masterDisposition = async () => {
        try {
            const getDisposition = await axios.get(
                PARTNER.GET_DISPOSITION,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );

            const data = decryptData(getDisposition.data);
            const decryptionRes = JSON.stringify(data)

            const doubleParse = JSON.parse(JSON.parse(decryptionRes))
            if (doubleParse.data) {
                setGetDispositionMaster(doubleParse.data.dispositions)
            }
            else {
                setGetDispositionMaster([])
            }
        } catch (error) {
            console.log(error);
        }
    };
    const masterPartner = async () => {
        try {
            const getPartner = await axios.get(
                PARTNER.MASTER_PARTNER,

                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
            const data = decryptData(getPartner.data);
            const decryptionRes = JSON.stringify(data)

            const doubleParsePartner = JSON.parse(JSON.parse(decryptionRes))
            if (doubleParsePartner.data) {
                setPartnerSource(doubleParsePartner.data.partnerCategories)
            }
            else {
                setPartnerSource([])
            }

        } catch (error) {
            console.log(error);
        }
    };
    // for pagination start
    const handleScroll = async (e) => {
        const a = e.target;
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
            if (!(totalCount <= 10 * page)) {
                setPage((prev) => prev + 1);
                setScrollLoader(true);
            }
        }
    };

    // for pagination end
    function handleTabStatus(status) {
        setTabStatus(status);
        setPage(1);
        setName("")
        localStorage.setItem("statusOfClient", status);
    }
    const handleOnChange = (e) => {
        localStorage.removeItem("dematLeadFromDate")
        localStorage.removeItem("dematLeadToDate")
        setPage(1);
        console.log(e?.target?.value, "durationBackoffice");
        if (e?.target?.value !== "") {
            localStorage.setItem("backofficeDuration", e?.target?.value)
            setDayWiseDate(e?.target?.value);
            setName("")
            if(e?.target?.value === "custom-range"){
                // setDayWiseDate("");
                setCustomDate(true)
            }
        }  
    };

    const statusUpdatedDisposition = async (disposition, id) => {
        let req = {
            id: id,
             disposition: parseInt(disposition)
        }
        let reqPayload = encryptData(JSON.stringify(req))
        
        try {
            const statusDisposition = await axios.put(
                PARTNER.STATUS_DISPOSITON,
                reqPayload,
                
                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
        } catch (error) {
            console.log(error);
        }
    };

    const statusUpdatedPartner = async (partnerSourceValue, id) => {
        let partReq = {
            id: id,
            partnerCategory: parseInt(partnerSourceValue)
        }
        let partnerPayload = encryptData(JSON.stringify(partReq))
        try {
            const statuspartner = await axios.put(
                PARTNER.STATUS_DISPOSITON,
                partnerPayload,
                

                {
                    headers: {
                        "Content-Type": "text/plain",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
        } catch (error) {
            console.log(error);
        }
    };

    const handleInputChange = (e, id) => {
        statusUpdatedDisposition(e.target.value, id)

    }
    const handlePartnerInput = (e, id) => {
        statusUpdatedPartner(e.target.value, id)
    }

    function SubmitButton() {
        if (fromDate && toDate) {
            localStorage.setItem("dematLeadFromDate", fromDate);
            localStorage.setItem("dematLeadToDate", toDate);

            return <button type="button" className="rej-btn " onClick={() => {
                onboardingApiData(page, tabStatus, 10, dayWiseDate); setCustomDate(false); setFromDate("")
                setToDate("")
            }}>Submit</button>
        } else {
            return <button type="button" className="rej-btn disable-btn" disabled>Submit</button>
        };
    };

    const deleteApi = async (id) => {
        try {
            const getResp = await axios.delete(
                `${PARTNER.DELETE_CLIENT_DATA}?id=${id}`,
                
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                    },
                }
            );
            let DataValue = decryptData(getResp?.data);
            const decryptDataVal = JSON.parse(DataValue)
            
            if (decryptDataVal?.status === 0) {
                toast.success(decryptDataVal?.message)
                onboardingApiData(page, tabStatus, 10, dayWiseDate);
            }
            else {
                toast.error(decryptDataVal?.message)
            }
        } catch (error) {
            console.log(error);
        }
    };

    const downloadFile = async(url, type)=>{
        setDownloadLoader(type);

    try{
        const response = await axios.get(url, {
          headers: {
            // "Content-Type": "text/plain",
                Authorization: `Bearer ${storeToken}`,
          }
    
        })
        const headers = response.headers
        if(headers["content-type"] !== "text/csv"){
          toast.error("No Data Found")
          return
        }
        const binary = [];
        binary.push(response.data)
        const href = window.URL.createObjectURL(new Blob(binary, {type: "text/csv"}))
        const link = document.createElement("a")
        link.href = href
        link.setAttribute("download", "lead.csv")
        document.body.appendChild(link)
        link.click();
    
        document.body.removeChild(link)
        window.URL.revokeObjectURL(href);
    }
    catch(error){
        console.error("Error during file download:", error);
        toast.error("Something went wrong, Please try again later.");
    }
      }

      const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    let mm = currentDate.getMonth() + 1;
    let dd = currentDate.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const FormatedDate = dd + "/" + mm + "/" + yyyy;
    const DateReverse = FormatedDate.split("/").reverse().join("-");

    return (
        <>
            <Header portal={"TELECALLER"} />
            {/* <Sidebar /> */}
            <SingleSignOnSideBar />
            <main id="main-content" className="onboarding-pending partner-onboarding">
                <div className="tab-content" id="myTabContent">
                    <Tab.Container id="left-tabs-example" activeKey={tabStatus}>
                        {/* page tabs */}
                        <div>
                            <Nav variant="nav tabs page-tabs partner-backoffice-nav">
                                <li
                                    className="nav-item"
                                    onClick={() => handleTabStatus("all")}
                                >
                                    <Nav.Link eventKey="all">All</Nav.Link>
                                </li>
                                <li
                                    className="nav-item"
                                    onClick={() => handleTabStatus("approved")}
                                >
                                    <Nav.Link eventKey="approved">Approved</Nav.Link>
                                </li>
                                <li
                                    className="nav-item"
                                    onClick={() => handleTabStatus("rejected")}
                                >
                                    <Nav.Link eventKey="rejected">
                                        Rejected
                                    </Nav.Link>
                                </li>

                                <li
                                    className="nav-item"
                                    onClick={() => handleTabStatus("active")}
                                >
                                    <Nav.Link eventKey="active">Active</Nav.Link>
                                </li>
                                <li
                                    className="nav-item"
                                    onClick={() => handleTabStatus("draft")}
                                >
                                    <Nav.Link eventKey="draft">Draft</Nav.Link>
                                </li>
                                <li
                                    className="nav-item"
                                    onClick={() => handleTabStatus("under-review")}
                                >
                                    <Nav.Link eventKey="under-review">Under Review</Nav.Link>
                                </li>
                            </Nav>
                        </div>

                        <div className="onboarding-secondary-tab-list">
                            <div className="search-box">
                                <div className="form-group">
                                    <div className="for-position oms-search">
                                        <input
                                            type="text"
                                            className="input-st"
                                            placeholder="Search here..."
                                            autoComplete="off"
                                            id="trad-map"
                                            value={name}
                                            onChange={(e) => {
                                                setName(e.target.value)
                                                setPage(1)
                                            }
                                            }
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="menu-rank-wrapper partner-menu">
                                <div 
                                onClick={()=>downloadFile(`${Baseurl}/partners/csv?status=${tabStatus}&range=${dayWiseDate}`, "csv")}
                                    className={
                                        partnerOnboardingData && partnerOnboardingData.length > 0
                                            ? ""
                                            : "disabled-link"
                                    }
                                >
                                    <span className="icon-download"></span>
                                    
                                </div>
                                <div className="card-right card-tabs">
                                    <div className="dropdown-filter">
                                        <Form.Select
                                            size="lg"
                                            aria-label="Default select example"
                                            onChange={handleOnChange}
                                            defaultValue={dayWiseDate}
                                        >
                                            <option value="this-month">This Month</option>
                                            <option value="today">Today</option>
                                            <option value="yesterday">Yesterday</option>
                                            <option value="this-week">This Week</option>
                                            <option value="last-week">Last Week</option>
                                            <option value="last-month">Last Month</option>
                                            <option value="till-date">Till Date</option>
                                            <option value="custom-range">Custom Range</option>
                                        </Form.Select>
                                    </div>
                                </div>
                                <div className="menu-wrapper">
                                    <span
                                        className="icon-block-menu"
                                        onClick={handleGridView}
                                    ></span>
                                    <span
                                        className="icon-horizontal-menu"
                                        onClick={handleListView}
                                    ></span>

                                </div>

                            </div >
                        </div >
                        <div className="for-grid-section partner-backoffice-onboarding">
                            {loader ? (
                                <div className="loader-alignment">
                                    <Loader />
                                </div>
                            ) : (
                                <Tab.Content>
                                    <PartnerOnboardingAll
                                        partnerOnboardingData={partnerOnboardingData}
                                        linecard={linecard}
                                        handleScroll={handleScroll}
                                        scrollLoader={scrollLoader}
                                        getDispositionMaster={getDispositionMaster}
                                        handleInputChange={handleInputChange}
                                        partnerSource={partnerSource}
                                        handlePartnerInput={handlePartnerInput}
                                        deleteApi={deleteApi}

                                    />
                                    <PartnerOnboardingApproved
                                        partnerOnboardingData={partnerOnboardingData}
                                        linecard={linecard} handleScroll={handleScroll}
                                        scrollLoader={scrollLoader}
                                        getDispositionMaster={getDispositionMaster}
                                        handleInputChange={handleInputChange}
                                        partnerSource={partnerSource}
                                        handlePartnerInput={handlePartnerInput}
                                        // deleteApi={deleteApi}
                                    />
                                    <PartnerOnboardingRejected
                                        partnerOnboardingData={partnerOnboardingData}
                                        linecard={linecard}
                                        handleScroll={handleScroll}
                                        scrollLoader={scrollLoader}
                                        getDispositionMaster={getDispositionMaster}
                                        handleInputChange={handleInputChange}
                                        partnerSource={partnerSource}
                                        handlePartnerInput={handlePartnerInput}
                                        deleteApi={deleteApi}
                                    />
                                    <PartnerOnboardingActive
                                        partnerOnboardingData={partnerOnboardingData}
                                        linecard={linecard}
                                        handleScroll={handleScroll}
                                        scrollLoader={scrollLoader}
                                        getDispositionMaster={getDispositionMaster}
                                        handleInputChange={handleInputChange}
                                        partnerSource={partnerSource}
                                        handlePartnerInput={handlePartnerInput}
                                        deleteApi={deleteApi}
                                    />
                                    <PartnerOnboardingDraft
                                        partnerOnboardingData={partnerOnboardingData}
                                        linecard={linecard}
                                        handleScroll={handleScroll}
                                        scrollLoader={scrollLoader}
                                        getDispositionMaster={getDispositionMaster}
                                        handleInputChange={handleInputChange}
                                        partnerSource={partnerSource}
                                        handlePartnerInput={handlePartnerInput}
                                        deleteApi={deleteApi}
                                    />
                                    <PartnerOnboardingUnderReview
                                        partnerOnboardingData={partnerOnboardingData}
                                        linecard={linecard}
                                        handleScroll={handleScroll}
                                        scrollLoader={scrollLoader}
                                        getDispositionMaster={getDispositionMaster}
                                        handleInputChange={handleInputChange}
                                        partnerSource={partnerSource}
                                        handlePartnerInput={handlePartnerInput}
                                        deleteApi={deleteApi}

                                    />
                                </Tab.Content>

                            )}
                        </div>
                    </Tab.Container >
                </div >
                {customDate && customDate ? <Modal
                    show={customDate}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className="setting-model partner-modal-rejection"
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            <h2 className="model-title">
                                Custom Date
                            </h2>
                        </Modal.Title>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close" >
                            <span className="icon-close" onClick={() => setCustomDate(false)}></span>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="custom-modal-wrapper row">

                            <div className="col-md-6 col-12">
                                <label className="form-label">{Constants.From_Date}</label>
                                <input
                                    type="date"
                                    placeholder="DD/MM/YYYY"
                                    className="form-input"
                                    onChange={e => setFromDate(e.target.value)}
                                    max={DateReverse}
                                />
                            </div>
                            <div className="col-md-6 col-12">
                                <label className="form-label">{Constants.To_Date}</label>
                                <input
                                    type="date"
                                    placeholder="DD/MM/YYYY"
                                    className="form-input"
                                    onChange={e => setToDate(e.target.value)}
                                    max={DateReverse}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <SubmitButton />
                    </Modal.Footer>
                </Modal> : null

                }
            </main >

        </>
    );
}

export default PartnerOnboardingDashboard;
